import i18n from '../language/i18n';

/**
 * Load localized data từ localData folder dựa vào language hiện tại
 * @param {string} dataName - Tên file (vd: 'menu', 'newsMenu')
 * @param {string} language - Language code (vd: 'vi', 'en', 'jp'), nếu không pass sẽ lấy từ i18n
 * @returns {Promise} - Return module chứa data
 */
// Normalize browser locale codes (e.g. en-US → en, ja-JP → jp) to app-internal codes
export const normalizeLang = (lang) => {
  const base = (lang || 'vi').split('-')[0].split('_')[0].toLowerCase();
  if (base === 'ja') return 'jp';
  return base;
};

